module.exports = __webpack_public_path__ + "static/media/cookie-mob-background.115f2ffb.svg";